export const JSON_ONE23NW = {
  source: "PostMan",
  requestDataType: "Transaction",
  requestData: {
    ag_ref: "jzZJUHNtz1qag7rt2pnsb2CFShTc59+Pg42wSg21CpA=",
    meId: "202402140001",
  },
};
